import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { ConfirmModalComponent } from '../../shared/component/confirm-modal/confirm-modal.component';
import { ExternalFilingRequestService } from '../../shared/services/exemptionFilingRequest';
import { ExternalCommonService } from '../../shared/services/external.common.service';

@Component({
  selector: 'app-mailin-payment-confirmation',
  templateUrl: './mailin-payment-confirmation.component.html',
  styleUrls: ['./mailin-payment-confirmation.component.scss'],
})
export class MailinPaymentConfirmationComponent implements OnInit {
  requestId: any;
  summaryData: any;
  isLoading = false;
  constructor( private dialog: MatDialog,
    private commonService: ExternalCommonService,
    private router: ActivatedRoute,
    private exemptionFilingRequestService: ExternalFilingRequestService
  ) {}

  ngOnInit(): void {
    this.requestId = +atob(this.router.snapshot.params.id);
    this.exemptionFilingRequestService
    .updateFillingStatusWebPrepered(this.requestId)
    .subscribe((res) => {
      console.log(res);
    });

    //PENDING
    this.exemptionFilingRequestService
      .getSummary(this.requestId)
      .subscribe((res) => {
        console.log(res);
        this.summaryData = res;
      });
  }

  onDownload() {
    this.isLoading = true;
    this.exemptionFilingRequestService
      .getRegDetailsDoc(this.requestId)
      .subscribe((doc: any) => {
        this.openFile(doc);
        this.isLoading = false;
      },
      error => {
        this.isLoading = false;
        this.dialog.open(ConfirmModalComponent, {
          data: {
            title: 'Error',
            warning: true,
            message: `Error occured while downloading an application.`,
          },
        });
      });
  }
  private openFile = (data: any) => {
    const byteCharacters = atob(data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    var blob = new Blob([byteArray], { type: 'application/pdf' });
    var url = window.URL.createObjectURL(blob);
    window.open(url, '_blank', '');
  };

  onClose() {
    window.location.href =
      'https://www.tn.gov/workforce/injuries-at-work/employers/employers/wc-exemption-registry.html';
  }
}
